// removed by extract-text-webpack-plugin
module.exports = {"container":"_3h8dH71vnezJWK4Abny-mH","delete":"_3dL3c6d5jp_yz8zsuK9aes","fieldContainer":"_1SLT8KXrDYXMuxU1q-34tF","contactlist":"_2fPpaxPxRmCV6kz1cmXyP"};


//////////////////
// WEBPACK FOOTER
// ./src/App/components/fields/Signers/styles.css
// module id = 2857
// module chunks = 0